// extracted by mini-css-extract-plugin
export default {"root":"external-link_root__clcPZ","linkIcon":"external-link_linkIcon__FMoBZ"};